import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { Property } from "./property.model";

/**
 * @class GuestsList
 * @property {number} id
 * @property {string} name
 * @property {string} description
 */
export class GuestsList extends TranslatableModel {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {

        return [ 'name' ];
    }

    static get validationModel() {

        return {
            name_ar: {
                label: 'ARABIC_LIST_NAME',
                commonLabel: 'Guest List Name'
            },
            name: {
                label: 'ENGLISH_LIST_NAME',
                commonLabel: 'Guest List Name'
            },
        };
    }

    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {

        return value instanceof Property ? value : new Property(value);
    }
}

AccessorsMutatorsDecorator('id', ...GuestsList.translatableAttributesWithLanguageAliases, 'description', 'updated_at', 'property_id', 'property')(GuestsList);


// WEBPACK FOOTER //
// ./src/pms-api/models/guests-list.model.js